import { render, staticRenderFns } from "./bdd.vue?vue&type=template&id=4418e484"
import script from "./bdd.vue?vue&type=script&lang=js"
export * from "./bdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports